import { utils, writeFile } from "xlsx";

export const exportToCSV = (data: any) => {
  let wb = utils.book_new(),
    ws = utils.json_to_sheet(data);
  utils.book_append_sheet(wb, ws, "items");
  writeFile(wb, "membership_tiering.csv");
};
